import React, { Component } from 'react';
import GridContainer from './containers/GridContainer';

const App = ({ children }) => {
    /* eslint-disable jsx-a11y/href-no-hash */
  return (
    <div className="app">
      {children}
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js